(function() {
    'use strict';

    angular
        .module('app')
        .factory('API', API);

    function API($http, apiConfig){
        var cache = {};

        var factory = {
            get: _get,
            post: _post,
			postFile: _postFile,
            put: _put,
            delete: _delete,
            cacheDestroy: _cacheDestroy,
            addCache: _addCache
        };

        function _get(url, param) {
            if(!_getCacheItem(url, param)){
                _setCacheItem(url, param, $http.get(apiConfig.url + '/api.php?t=' + url + '&p=' + param));
            }
            return _getCacheItem(url, param).then(result => angular.copy(result));
        };

        function _post(url, params) {
            return $http.post(apiConfig.url + '/api.php?t='+url, params);
        };

		function _postFile(url, params){
			let newData = new FormData();
			angular.forEach(params, (value, key) => newData.append(key, value));
			return $http.post(apiConfig.url + '/api.php?t=' + url, newData, {
	            transformRequest: angular.identity,
	            headers: {'Content-Type': undefined}
	        });
		}

        function _put(url, params) {
            return $http.put(apiConfig.url + '/api.php?t='+url, params);
        };

        function _delete(url, params) {
            return $http.delete(apiConfig.url + '/api.php?t='+url, params);
        };

        function _cacheDestroy(){
            cache = {};
        }

        function _addCache(key, value){
            cache[key] = value;
        }

        /* Privates */

        function _getCacheItem(url, param){
            return cache[_urlToKey(url, param)];
        }

        function _setCacheItem(url, param, item){
            cache[_urlToKey(url, param)] = item;
        }

        function _urlToKey(url, param){
            var key = '?t=' + url;
            if(param){
                key += '&p=' + param;
            }
            return key;
        }

        return factory;
    }

})();
